import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'

interface CamplusLogoProps {
  /** Fill colour – defaults to white */
  color?: string
  /** Width in px – height scales proportionally */
  width?: number
  sx?: SxProps<Theme>
}

export const CamplusLogo: React.FC<CamplusLogoProps> = ({ color = '#fff', width = 120, sx }) => {
  const height = (width * 27) / 102

  return (
    <Box
      component="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 102 27"
      aria-label="Camplus"
      role="img"
      sx={{
        width,
        height,
        fill: color,
        display: 'block',
        flexShrink: 0,
        ...(sx as Record<string, unknown>)
      }}
    >
      <path d="M7.4 7.2c.6 0 1.1 0 1.6.3v2.8c.4.3.7.4 1.1.4.9 0 1.7-.6 1.7-1.7 0-1.6-2-2.6-4.4-2.6S0 8.4 0 13.8s2.7 7 6.6 7 2.9-.4 4.6-1.2c.2-.1.3-.3.3-.5v-.3c0-.3-.2-.4-.5-.2-1.1.6-2.2.9-3.2.9-3.2 0-4.7-3.1-4.7-6.3s1.4-6 4.1-6m13-.9c-2.9 0-5.5 1.5-5.5 3.2s.6 1.3 1.4 1.3.8-.1 1.3-.3V7.8c.6-.3 1.5-.5 2.3-.5 1.6 0 2.9.8 2.9 2.9v1.6c-.2 0-.6.1-.9.2-3.6.7-7.6 2-7.6 5.3s1.9 3.5 4.2 3.5 3.5-.7 4.3-1.8l.2 1.6h2.1c.5 0 .6-.3.6-.7V11c0-3.4-2.6-4.7-5.4-4.7Zm2.4 10.6c0 1.6-1.5 2.5-3 2.5s-2.5-1.2-2.5-2.5 1-2.9 3.5-3.7c.5-.2 1.4-.4 2-.6v4.2ZM44.7 6.3c-1.6 0-3.3.8-4.1 2.2-.7-1.5-2.4-2.2-4-2.2s-3.3.7-4.1 2.1v-2l-5 .7v.7h1.4c.5 0 .7.3.7.8v11.2c0 .4.2.7.7.7h1.6c.5 0 .6-.3.6-.7v-8.9c0-2 1.4-3.1 2.9-3.1s2.6.9 2.6 2.9v9.1c0 .4.2.7.6.7h1.6c.5 0 .6-.3.6-.7v-8.9c0-2 1.4-3.1 2.9-3.1s2.6 1 2.6 3v9c0 .4.2.7.7.7h1.6c.5 0 .7-.3.7-.7v-9.1c0-2.9-2.1-4.5-4.4-4.5m15.1.1c-1.5 0-2.9.7-3.8 2V6.4l-4.9.7v.7h1.4c.5 0 .6.3.6.8v17.5c0 .3.2.7.6.7h1.6c.5 0 .6-.3.6-.7v-6.3c.7.6 1.7 1 3 1 4.2 0 6.4-3.3 6.4-7.6s-3-6.9-5.6-6.9Zm-1.2 13.4c-.8 0-1.8-.3-2.6-1.1V11c0-2 1.3-3.2 2.9-3.2s3.4 2.3 3.4 5.6-1.3 6.3-3.7 6.3m8-18.1h1.4c.5 0 .7.3.7.8v17.5c0 .4.2.7.7.7h1.6c.5 0 .6-.3.6-.7V.1l-5 .7zm16.3 6.3h1.4c.5 0 .7.3.7.8v7.6c0 2.4-1.7 3-3 3s-2.8-.7-2.8-2.8V6.4l-5 .7v.7h1.4c.5 0 .7.3.7.8v8c0 2.8 2.2 4.1 4.6 4.1s3.3-.7 4.1-1.9v1c0 .4.2.7.6.7h1.6c.5 0 .7-.3.7-.7V6.4l-5 .7v.7Zm11.1 1.6c0-1.5 1.3-2.2 2.7-2.2s2.5.5 3.4 1.3c.3.2.6.1.6-.2v-.2c0-.2 0-.4-.3-.6-.9-.9-2.6-1.3-4.1-1.3-2.5 0-5.1 1.4-5.1 4.2 0 4.6 7.8 3.6 7.8 6.9s-1.4 2.3-3.1 2.3-3-.5-4.2-1.6c-.3-.2-.6-.1-.6.2v.3c0 .2 0 .4.3.6 1.1 1.1 3 1.7 4.9 1.7 2.8 0 5.4-1.4 5.4-4.3 0-4.9-7.7-4.1-7.7-7.1" />
    </Box>
  )
}
